let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("htJAW")).then(() => parcelRequire('h6MfM'));